import React from 'react';

import { appMethod as app } from '@utils/app';
import { transformPx2Rem, convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './NewSuspensionCustomComponent.less';

export default class NewSuspensionCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
  }

  unfoldSus = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let tapType = e.currentTarget.dataset.taptype;
    pageInstance.setData({
      ['eles[' + compindex + '].customFeature.buttonHidden']: tapType === 'heightSus' ? true : (tapType === 'foldSus' ? false : false)
    });
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 组件特性数据处理
     */
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = {
      ...convertStyleData(data.style),
      bottom: transformPx2Rem(app.isTabBarPage() ? (parseInt(data.style.bottom) + 48) : data.style.bottom, 320),
    };
    let wrapStyleObj = {
      borderRadius: transformPx2Rem(customFeature["border-radius"], 320),
    }
    if (!customFeature.backgroundType) {
      wrapStyleObj['backgroundColor'] = customFeature.lineBackgroundColor;
    } else {
      wrapStyleObj['background'] = customFeature.lineBackgroundImage;
    }
    if (customFeature.pickUpType == 2) {
      // wrapStyleObj['width'] = 0; // 暂时没有动画
    } else {
      // wrapStyleObj['height'] = 0; // 暂时没有动画
    }
    if (customFeature.suspensionShowList.length > 2 && customFeature.pickUpType == 1) {
      // wrapStyleObj['height'] = transformPx2Rem(customFeature.height, 320); // 小程序好像有问题
    } else {
      // wrapStyleObj['width'] = transformPx2Rem(customFeature.width, 320);  // 小程序好像有问题
    }
    let itemStyleObj = {
      marginTop: customFeature['margin-bottom'],
      marginBottom: customFeature['margin-bottom'],
    }
    if (customFeature.suspensionShowList.length == data.content.length) {
      itemStyleObj['marginLeft'] = customFeature['margin-right'];
      itemStyleObj['marginRight'] = customFeature['margin-right'];
    }
    itemStyleObj = convertStyleData(itemStyleObj);
    const itemImgStyleObj = {
      width: transformPx2Rem(customFeature['icon-size'], 320),
      height: transformPx2Rem(customFeature['icon-size'], 320),
      borderRadius: transformPx2Rem(customFeature['icon-radius'], 320),
      opacity: customFeature['icon-opacity'],
    }
    const btnStyleObj = {
      background: customFeature.pickUpIcon || '',
      backgroundSize: 'contain'
    }
    const navStyleObj = {
      width: transformPx2Rem(customFeature.navigationWidth, 320),
      height: transformPx2Rem(customFeature.navigationHeight, 320),
      right: transformPx2Rem(customFeature.navigationRight, 320),
      bottom: transformPx2Rem(app.isTabBarPage() ? (parseInt(customFeature.navigationBottom) + 48) : customFeature.navigationBottom, 320),
      opacity: customFeature.opacity,
    }
    const unfoldBtnStyleObj = {
      background: data.customFeature.spreadIcon || '',
      backgroundSize: 'contain',
      width: '100%',
      height: '100%',
      borderRadius: transformPx2Rem(customFeature.navigationRadius, 320),
    }
    /**
     * 组件内容处理
     */   
    let content = data.content;
    /**
     * 返回组件
     */ 
    return (
      <div className="custom-component new-suspension">
        <div className="newSuspension" style={styleObj}>
          <div className={`newSuspension-wrap ${data.customFeature.pickUpLocation == 'left' ? '' : 'newSuspension-right'} ${data.customFeature.pickUpType == 1 ? '':'newSuspension-round'} ${data.customFeature.structure == 1 ? '':'newSuspension-structure'}`} 
            style={wrapStyleObj}
            >
            <div className={`newSuspension-box ${customFeature.buttonHidden ? '':'newSuspension-hiddenBtn'}`}
              style={{
                padding: customFeature.suspensionShowList.length == data.content.length ? '.20rem 0' : ''
              }}
              >
                {
                  customFeature.suspensionShowList && customFeature.suspensionShowList.map((item, index) => (
                    <div key={index} className="newSuspension-item-box">
                      {
                        item.map((subItem, subIndex) => (
                          <div key={subIndex} className="newSuspension-item"
                            style={itemStyleObj}
                            onClick={() => customEvent({customFeature: subItem.customFeature})}>
                            <img src={subItem.pic} style={itemImgStyleObj}/>
                            <span className="item-name">{subItem.title}</span>
                        </div>
                        ))
                      }
                    </div>
                  ))
                }
                {
                  (customFeature.pickUpType == 1 && customFeature.structure == 1) &&
                  <div className={`newSuspension-btmBar ${customFeature.suspensionShowList.length == data.content.length ? 'marginAuto' : 'float'}`}
                    onClick={this.unfoldSus}
                    data-compindex={this.props.index}
                    data-taptype="foldSus"
                    >
                    <div className='unfoldBtn' style={btnStyleObj}></div>
                  </div>
                }
                {
                  (customFeature.pickUpType == 1 && customFeature.structure == 2) &&
                  <div className="newSuspension-close"
                    onClick={this.unfoldSus}
                    data-compindex={this.props.index}
                    data-taptype="foldSus"
                    style={{
                      background: customFeature.pickUpIcon,
                      backgroundSize: 'contain'
                    }}
                    >
                    <div className='unfoldBtn' style={btnStyleObj}></div>
                  </div>
                }
                {
                  (customFeature.pickUpType == 2 && customFeature.pickUpLocation == 'left') &&
                  <div className="newSuspension-sideBar"
                    onClick={this.unfoldSus}
                    data-compindex={this.props.index}
                    data-taptype="foldSus"
                    style={{
                      background: customFeature.pickUpIcon,
                      backgroundSize: 'contain'
                    }}
                    >
                    <div className='unfoldBtn' style={btnStyleObj}></div>
                  </div>
                }
                {
                  (customFeature.pickUpType == 2 && customFeature.pickUpLocation == 'right') &&
                  <div className="sideBarRight"
                    onClick={this.unfoldSus}
                    data-compindex={this.props.index}
                    data-taptype="foldSus"
                    style={{
                      background: customFeature.pickUpIcon,
                      backgroundSize: 'contain'
                    }}
                    >
                    <div className='unfoldBtn' style={btnStyleObj}></div>
                  </div>
                }
              </div>
          </div>
        </div>
        {
          !customFeature.buttonHidden &&
          <div className={`sideBarRightOut ${customFeature.pickUpType == 1 ? 'roundBar' : '' } ${customFeature.pickUpType == 1 ? '':'newSuspension-round'} ${customFeature.structure == 1 ? '':'newSuspension-structure'}`}
            data-compindex={ this.props.index }
            style={navStyleObj}
            onClick={this.unfoldSus}
            data-taptype='heightSus'
            >
            <div className="unfoldBtn"
              style={unfoldBtnStyleObj}></div>
          </div>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/new-suspension-custom-component/NewSuspensionCustomComponent.jsx